import { InjectionToken } from '@angular/core';

export const CATEGORY_NAME_MAX_LENGTH_INJECTION_TOKEN = new InjectionToken<number>(
  'category-name-max-length-injection-token',
);
